import { defineStore } from 'pinia';

export default defineStore('navbarButton Store', {
  state: () => ({
    filterMenuSwitch: false, // 篩選側欄
  })
})